import React from 'react';

import { useRef, useEffect, useCallback } from 'react';

const USER_ACTIVATION_EVENTS = [
    "auxclick",
    "click",
    "contextmenu",
    "dblclick",
    "keydown",
    "keyup",
    "mousedown",
    "mouseup",
    "touchend"
  ];

const DummyAudio = () => {
    const dummyPlayed = useRef(false);

    const handleUserActivation = () => {
        if (!dummyPlayed.current) {
            dummyPlayed.current = true;
          document.getElementById("dummyAudio").play();
          
        }
      };

      const setupAudioHandlers = () => {
        USER_ACTIVATION_EVENTS.forEach((eventName) => {
          window.addEventListener(eventName, handleUserActivation, {
            capture: true,
            passive: true
          });
        });
      };
    
      
      useEffect(() => {
          // play the audio element on the page to override the iOS mute switch :) 🔕
        setupAudioHandlers();
      },[]);

    return <audio id="dummyAudio" src={`${process.env.PUBLIC_URL}/audio/nothing.ogg`}></audio>

}

export default DummyAudio